import React, { useState } from 'react'
import styled from 'styled-components'
import { Colors } from '../../constants'
import { CurrencyValue, Pair } from '../../model'
import { SwapIntoTooltip } from './SwapIntoTooltip'

interface Props {
  pair?: Pair
  showCalculatedValue: boolean
  controlled: 'first' | 'second'
  firstValue: CurrencyValue
  secondValue: CurrencyValue
  firstRate?: string
  secondRate?: string
  swapFee?: CurrencyValue
  slippagePercent?: string
}

export function SwapInfo({
  showCalculatedValue,
  controlled,
  firstValue,
  secondValue,
  firstRate,
  secondRate,
  swapFee,
  slippagePercent,
}: Props) {
  const [priceDirection, setPriceDirection] = useState(true)

  function togglePrice() {
    setPriceDirection(!priceDirection)
  }

  if (showCalculatedValue && firstRate && secondRate && swapFee && slippagePercent) {
    const priceDisplay = priceDirection ? secondRate : firstRate

    return (
      <Content>
        <Price onClick={togglePrice}>
          {priceDisplay}
          <SwapIntoTooltip
            controlled={controlled}
            firstValue={firstValue}
            secondValue={secondValue}
            swapFee={swapFee}
            slippagePercent={slippagePercent}
          />
        </Price>
      </Content>
    )
  } else {
    return <></>
  }
}

const Content = styled.div`
  margin-bottom: 20px;
  padding: 0 20px;
`

const Price = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 11px;
  color: ${Colors.DarkerGray};
  cursor: pointer;
`
